import React, { SVGAttributes } from 'react';
import css from './index.module.scss';

type GuidelineGroupProps = Omit<SVGAttributes<SVGGElement>, 'className'>;

export const GuidelineGroup: React.FC<GuidelineGroupProps> = props => (
  <g data-component="GuidelineGroup" className={css.guideline} {...props} />
);
